import { Grid } from '@mantine/core';
import SummaryCard from '../../../components/Dashboard/SummaryCard';
import SummaryTopCard from '../../../components/Dashboard/SummaryTopCard';
import DashboardsCommon from '../../../components/DashboardsCommon';
import prettifiedLabel from '../../../constants/labelPrettifier';
import statsToSummary from '../../../constants/StatsToSummary';

const TrafficTab = ({ stats, prevStats }) => {
  const pageViewsByUtmSourcePieChartData = stats
    ? stats.pageViews.grouped.bySource.count.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';
  const pageViewsByUtmMediumPieChartData = stats
    ? stats.pageViews.grouped.byMedium.count.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';

  const prevPageViewsByUtmSourcePieChartData = prevStats
    ? prevStats.pageViews.grouped.bySource.count.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';
  const prevPageViewsByUtmMediumPieChartData = prevStats
    ? prevStats.pageViews.grouped.byMedium.count.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';

  const filteredStats = (stats) => {
    return Object.keys(stats)
      .filter(
        (key) =>
          // cartAdds is engagement, not traffic — it was only here because it was
          // missing from this exclusion list, and it already has a tile on the
          // Engagement tab, where the same number was reported twice.
          ![
            'otherPageViews',
            'bannerPurchases',
            'cartAdds',
            'cartCreates',
            'purchases',
            'recommenderPurchases',
          ].includes(key)
      )
      .reduce((obj, key) => {
        obj[key] = stats[key];
        return obj;
      }, {});
  };

  return (
    <>
      <Grid data-tour="summaryCardTrafficTab" pt="sm">
        <SummaryCard
          currentPeriodData={statsToSummary(filteredStats(stats.totals.personalizations))}
          previousPeriodData={statsToSummary(filteredStats(prevStats.totals.personalizations))}
          currency=""
          size="3"
        />
      </Grid>
      <Grid mt="md">
        <Grid.Col span={12} data-tour="relevaVsOtherViewChart">
          <DashboardsCommon
            stats={stats.personalization
              .filter((s) => s.id === 'otherPageViews' || s.id === 'assistedPageViews')
              .map((s) => ({
                ...s,
                id: prettifiedLabel(s.id),
                color: s.id === 'assistedPageViews' ? 'var(--mantine-color-primary-filled)' : 'var(--mantine-color-gray-3)',
              }))}
            pieChartData={[
              {
                id: 'releva',
                label: 'Releva Contributed',
                value: stats.totals.personalizations.assistedPageViews,
                color: 'var(--mantine-color-primary-filled)',
              },
              {
                id: 'other',
                label: 'Other',
                value: stats.totals.personalizations.otherPageViews,
                color: 'var(--mantine-color-gray-3)',
              },
            ]}
            chartTitle="Releva Contributed vs Other Page Views"
            lineStacked={false}
            type={'card'}
          />
        </Grid.Col>
      </Grid>
      <Grid mt="md">
        <Grid.Col span={{ base: 12, md: 6 }} data-tour="storeTrafficSource">
          <SummaryTopCard
            stats={stats.pageViews.grouped.bySource.count}
            chart={'line'}
            currentPeriodData={pageViewsByUtmSourcePieChartData}
            previousPeriodData={prevPageViewsByUtmSourcePieChartData}
            badgeName="Top 3 Page views by source"
            numElements={3}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }} data-tour="storeTrafficMedium">
          <SummaryTopCard
            stats={stats.pageViews.grouped.byMedium.count}
            chart={'line'}
            currentPeriodData={pageViewsByUtmMediumPieChartData}
            previousPeriodData={prevPageViewsByUtmMediumPieChartData}
            badgeName="Top 3 Page views by medium"
            numElements={3}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default TrafficTab;
